(function () {
  const gate = document.querySelector('[data-ssc-age]');
  if (gate) {
    let approved = false;
    try { approved = sessionStorage.getItem('ssc-age-confirmed') === 'yes'; } catch (e) {}
    if (approved) { gate.remove(); }
    else {
      document.body.classList.add('ssc-gated');
      gate.focus();
      const yes = gate.querySelector('[data-ssc-age-yes]');
      const no = gate.querySelector('[data-ssc-age-no]');
      yes && yes.addEventListener('click', function () {
        try { sessionStorage.setItem('ssc-age-confirmed', 'yes'); } catch (e) {}
        document.body.classList.remove('ssc-gated');
        gate.remove();
      });
      no && no.addEventListener('click', function () { window.location.replace('about:blank'); });
      gate.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(gate.querySelectorAll('button'));
        if (!focusable.length) return;
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    }
  }
  const galleryDialog = document.querySelector('[data-ssc-lightbox]');
  if (galleryDialog && typeof galleryDialog.showModal === 'function') {
    document.querySelectorAll('[data-ssc-gallery-link]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        const image = galleryDialog.querySelector('img');
        image.src = link.href;
        image.alt = link.querySelector('img')?.alt || 'Fotografía ampliada';
        galleryDialog.showModal();
      });
    });
    galleryDialog.querySelector('[data-ssc-gallery-close]')?.addEventListener('click', function () { galleryDialog.close(); });
    galleryDialog.addEventListener('click', function (event) { if (event.target === galleryDialog) galleryDialog.close(); });
  }
  document.querySelectorAll('[data-ssc-variant]').forEach(function (select) {
    select.addEventListener('change', function () {
      const price = select.selectedOptions[0] && select.selectedOptions[0].dataset.price;
      const detail = select.closest('.ssc-detail-content');
      const priceNode = detail && detail.querySelector('.ssc-detail-price');
      if (price && priceNode) priceNode.textContent = price;
    });
  });
})();
